import _ from 'lodash';
import { createSelector } from 'reselect';
import { getIsTeacher } from '../base/local';
import { toState } from '../base/redux';
export const getTestType = (stateful) => {
    const state = toState(stateful);
    return state['features/test'].testType;
};
export const getSurveyFrequencyById = (stateful, test_id) => {
    const id = test_id || getFocusTestId(stateful);
    const state = toState(stateful);
    const list = state['features/test'].surveyFrequency;
    return list.get(id) || {};
};
export const getSubmitUser = (stateful) => {
    const state = toState(stateful);
    return state['features/test'].selectUserSubmit;
};
export const getSubmitUserByTestIdAndMemberId = (stateful, test_id, member_id) => {
    if (!test_id)
        return false;
    if (!member_id)
        return false;
    const submitStatus = getTestSubmitStatusByTestId(stateful, test_id);
    return submitStatus?.items?.find((member) => member.member_id === member_id) || [];
};
export const getSubmitUserScoreByTestId = (stateful, test_id) => {
    if (!test_id)
        return 0;
    const selectedMember = getFocusUser(stateful);
    if (!selectedMember) {
        const submitStatus = getTestSubmitStatusByTestId(stateful, test_id);
        return submitStatus?.total_score || 0;
    }
    if (!selectedMember) {
        return 0;
    }
    else {
        const submit = getSubmitUser(stateful);
        return submit?.score === -1 ? 0 : submit?.score || 0;
    }
};
export const getIsSubmitUser = (stateful) => {
    const isTeacher = getIsTeacher(stateful);
    const user = getSubmitUser(stateful);
    if (isTeacher) {
        const selectUser = getFocusUser(stateful);
        if (user === undefined) {
            return selectUser && !user ? true : false;
        }
        else {
            return selectUser && selectUser.id === user.member_id && user.not_submitted;
        }
    }
    return user === undefined ? 'loading' : user.not_submitted;
};
export const getSubjectName = (stateful) => {
    const item = getTestItemByTestId(stateful);
    return item?.type || '';
};
export const getSubmitData = (questionList, answerList) => {
    let mergedList = [];
    // answerList를 Map으로 변환하여 빠른 탐색 가능하도록 변경
    const answerMap = new Map(answerList.map(answer => [answer.question_id, answer]));
    // questionList와 answerMap을 병합
    mergedList = questionList
        .map((question) => {
        if (answerMap.size === 0) {
            return {
                ...question,
                question_id: question.id,
                value: '-',
                from: '',
                from_name: '',
                correction: '',
            };
        }
        const answer = answerMap.get(question.id);
        if (answer) {
            return {
                ...question,
                ...answer,
            };
        }
    })
        .filter(Boolean);
    return mergedList;
};
export const getQuestions = (stateful, test_id) => {
    const id = test_id || getFocusTestId(stateful);
    const state = toState(stateful);
    const list = state['features/test'].questionList;
    return list.get(id) || [];
};
export const getOmrFrequency = (stateful, test_id) => {
    const id = test_id || getFocusTestId(stateful);
    const state = toState(stateful);
    const omrFrequency = state['features/test'].omrFrequency;
    return (omrFrequency.get(id) || { server: { subject_items: '', answers: [] }, client: { subject_items: '', answers: [] } });
};
let previousState;
let previousResult;
export const getSurveySave = (stateful, test_id) => {
    const id = test_id || getFocusTestId(stateful);
    const state = toState(stateful);
    // 현재 상태가 이전 상태와 동일하면 이전 결과 반환
    if (previousState === state) {
        return previousResult;
    }
    const surveySave = state['features/test'].surveySave.get(id) || {
        server: { subject_items: '', answers: [] },
        client: { subject_items: '', answers: [] },
    };
    // 상태와 결과를 저장하여 이후 동일한 상태에 대해 같은 참조 반환
    previousState = state;
    previousResult = surveySave;
    return surveySave;
};
export const getStatisticsOption = (stateful) => {
    const state = toState(stateful);
    return state['features/test'].staticsOptions;
};
export const getAnswerList = (stateful, test_id) => {
    const id = test_id || getFocusTestId(stateful);
    const state = toState(stateful);
    const list = state['features/test'].answerList;
    return list;
};
export const getTestNoticeMessage = (stateful) => {
    const state = toState(stateful);
    return state['features/test'].testNoticeMessage;
};
export const getTestList = (stateful) => {
    const state = toState(stateful);
    const isTeacher = getIsTeacher(stateful);
    const list = state['features/test'].list;
    if (isTeacher)
        return list;
    else
        return list.filter((item) => item.status === 'open' || item.status === 'closed') || [];
};
export const getTestItemByTestId = (stateful, test_id) => {
    const id = test_id || getFocusTestId(stateful);
    if (!id) {
        const list = getTestList(stateful);
        return list.find((testItem) => testItem.status === 'open');
    }
    const list = getTestList(stateful);
    return id && id !== '' ? list.find((item) => item.id === id) : undefined;
};
export const getTestStatistics = (stateful) => {
    const state = toState(stateful);
    return state['features/test'].statistics;
};
export const getTestStatisticsByTestId = (stateful, testId) => {
    const data = getTestStatistics(stateful);
    return data.find((item) => item.test_id === testId);
};
export const getTestSubmitStatus = (stateful) => {
    const state = toState(stateful);
    return state['features/test'].submitStatus;
};
export const getTestSubmitStatusByTestId = (stateful, testId) => {
    const submitStatus = getTestSubmitStatus(stateful);
    return submitStatus.get(testId);
};
export const getIsEnterTestRoom = (stateful) => {
    const state = toState(stateful);
    return state['features/test'].isEnterRoom;
};
export const getIsMockMode = (stateful) => {
    const state = toState(stateful);
    return state['features/test'].isMockMode;
};
export const getFocusTestId = (stateful) => {
    const state = toState(stateful);
    return state['features/test'].selectTestId;
};
// 모의고사 개별 타이머가 '시작됨'으로 표시된 test_id 목록 (red_time/풀이화면 타이머 표시 게이트).
export const getStartedPersonalTimers = (stateful) => {
    const state = toState(stateful);
    return state['features/test'].personalStartedTimers || [];
};
// 특정 테스트의 개별 타이머가 시작되었는지 여부.
export const getIsPersonalTimerStarted = (stateful, testId) => {
    if (!testId)
        return false;
    return getStartedPersonalTimers(stateful).indexOf(testId) !== -1;
};
// 풀이시간 종료(무제출 포함) redux 신호 — sessionStorage 마커(mock_timeup)와 달리 리렌더를 유발한다.
export const getIsTestTimeUp = (stateful, testId) => {
    if (!testId)
        return false;
    const state = toState(stateful);
    return (state['features/test'].timeUpTests || []).indexOf(testId) !== -1;
};
export const getFocusUser = (stateful) => {
    const state = toState(stateful);
    return state['features/test'].selectUser;
};
export const getTestBackgroundUrl = (stateful) => {
    const state = toState(stateful);
    return state['features/test'].backgroundUrl;
};
export const getIsTestOpenModal = (stateful) => {
    const state = toState(stateful);
    return state['features/test'].openModal;
};
export const getIsTestFoldModal = (stateful) => {
    const state = toState(stateful);
    return state['features/test'].foldModal;
};
export const createSurveyData = (testItem, questionList, submittedAnswers) => {
    let surveyData = [];
    const surveyQuestions = testItem?.survey_questions;
    if (surveyQuestions) {
        for (const [id, survey] of Object.entries(surveyQuestions)) {
            const questionItem = questionList.find(item => item.id === id);
            const submittedAnswer = submittedAnswers &&
                submittedAnswers?.filter(answer => answer.question_id.includes(id))?.flatMap(item => item.values);
            if (!questionItem)
                continue;
            if (questionItem.type === 'choice' || questionItem.type === 'checkbox') {
                surveyData.push({
                    number: questionItem.number,
                    id: questionItem.id,
                    type: questionItem.type,
                    title: survey.title,
                    data: survey.options.map((option, optionIndex) => {
                        return {
                            id: `${questionItem.id}-${optionIndex}`,
                            title: option,
                            checked: submittedAnswer.includes(option),
                        };
                    }),
                });
            }
            else {
                surveyData.push({
                    number: questionItem.number,
                    id: questionItem?.id,
                    type: questionItem?.type,
                    title: survey?.title,
                    data: submittedAnswer,
                });
            }
        }
    }
    return surveyData.sort((a, b) => a.number - b.number);
};
export const getSubmittedAttachmentData = (stateful) => {
    const state = toState(stateful);
    const answerData = state['features/test'].answerList;
    const valuesArray = answerData.map(item => item?.value);
    return valuesArray;
};
// 상태에서 questionList와 frequenciesList를 가져오는 셀렉터
const getQuestionListSelector = (stateful) => getQuestions(stateful);
const getOmrFrequencySelector = (stateful) => getOmrFrequency(stateful);
const getSurveySaveSelector = (stateful) => getSurveySave(stateful);
// 선택된 과목 리스트와 선택한 과목을 반환하는 셀렉터
export const getSelectedSubjectListAndSelectSubject = createSelector([getTestItemByTestId, getQuestionListSelector, getOmrFrequencySelector], (testItem, questionList, frequenciesList) => {
    // subject_item이 선택되어 있는지 확인하고 중복 제거
    const subjectList = Array.from(new Set(questionList.map(item => item.subject_item) // "공통"이 포함되지 않은 subject_item만 필터링
    ));
    // 택1 선택과목 선택 창: '공통' 그룹이 있는 테스트에서 노출(기본형 math/korean + 동일 구조의 OMR 자유형).
    // 자유형은 subject 에 성적표명/과목명이 저장돼 과목 기준 게이트가 불가하므로 '공통' 그룹 유무로 판별.
    // 영어(듣기/읽기)는 공통 그룹이 없어 자연히 제외된다.
    if (testItem && subjectList.some(item => item && item.includes('공통'))) {
        const subjectItems = subjectList.filter(item => item && !item.includes('공통')); // "공통"이 포함되지 않은 subject_item만 필터링
        // 현재 선택된 과목 리스트가 있는지 조회
        const selectedSubject = frequenciesList?.server?.subject_items?.length > 0 ? frequenciesList.server.subject_items : undefined;
        if (subjectItems.length <= 1) {
            return {
                subjectList,
                selectedSubjectList: [],
                selectedSubject: '',
                isChoice: true,
            };
        }
        else {
            const subject = selectedSubject && selectedSubject.length > 0 ? frequenciesList.client.subject_items : selectedSubject;
            const selectedSubjectList = testItem.subject === 'math'
                ? subjectItems.sort((a, b) => {
                    const subjectOrder = ['선택 - 미적분', '선택 - 확률과 통계', '선택 - 기하'];
                    return subjectOrder.indexOf(a) - subjectOrder.indexOf(b);
                })
                : subjectItems;
            return {
                subjectList,
                selectedSubjectList: selectedSubjectList,
                selectedSubject: !subject ? undefined : subject?.length <= 0 ? undefined : subject,
                isChoice: !subject || selectedSubject?.length <= 0 ? false : true,
            };
        }
    }
    else {
        return {
            subjectList,
            selectedSubjectList: [],
            selectedSubject: '',
            isChoice: true,
        };
    }
});
export const getMergeOmrFrequency = createSelector([getOmrFrequencySelector], frequenciesList => {
    if (!frequenciesList || !frequenciesList.server || !frequenciesList.client) {
        return { subject_items: [], answers: [] };
    }
    const cloneFrequenciesList = _.cloneDeep(frequenciesList);
    // server.answers와 client.answers 병합
    const mergedAnswers = [
        ...(cloneFrequenciesList.server.answers || []),
        ...(cloneFrequenciesList.client.answers || []),
    ];
    // Map을 사용해 중복된 question_id 제거
    const uniqueAnswersMap = new Map(mergedAnswers.map(answer => [answer.question_id, answer]));
    const uniqueAnswers = Array.from(uniqueAnswersMap.values());
    return {
        subject_items: !cloneFrequenciesList.server.subject_items ||
            cloneFrequenciesList.server.subject_items.length <= 0
            ? cloneFrequenciesList.client.subject_items || []
            : cloneFrequenciesList.server.subject_items,
        answers: uniqueAnswers,
    };
});
export const getOmrFrequencyByTestId = (stateful, test_id) => {
    const omrFrequency = getOmrFrequency(stateful, test_id);
    const cloneFrequenciesList = _.cloneDeep(omrFrequency);
    return {
        subject_items: !cloneFrequenciesList.server.subject_items || cloneFrequenciesList.server.subject_items.length <= 0
            ? cloneFrequenciesList.client.subject_items
            : cloneFrequenciesList.server.subject_items,
        answers: _.merge(cloneFrequenciesList.server.answers, cloneFrequenciesList.client.answers),
    };
};
export const getMergeSurveySave = createSelector([getSurveySaveSelector], frequenciesList => {
    const cloneFrequenciesList = _.cloneDeep(frequenciesList);
    return {
        subject_items: !cloneFrequenciesList.server.subject_items || cloneFrequenciesList.server.subject_items.length <= 0
            ? cloneFrequenciesList.client.subject_items
            : cloneFrequenciesList.server.subject_items,
        answers: _.merge(cloneFrequenciesList.server.answers || [], cloneFrequenciesList.client.answers || []) || [],
    };
});
export const getMergeData = (data) => {
    const cloneFrequenciesList = _.cloneDeep(data);
    const mergedAnswers = (Array.isArray(cloneFrequenciesList.client.answers) && cloneFrequenciesList.client.answers.length > 0)
        ? cloneFrequenciesList.client.answers
        : cloneFrequenciesList.server.answers || [];
    return {
        subject_items: !cloneFrequenciesList.server.subject_items || cloneFrequenciesList.server.subject_items.length <= 0
            ? cloneFrequenciesList.client.subject_items
            : cloneFrequenciesList.server.subject_items,
        // answers: _merge(cloneFrequenciesList.server.answers || [], cloneFrequenciesList.client.answers || []) || [],
        answers: mergedAnswers,
    };
};
export const getMergeSurveySaveById = (stateful, test_id) => {
    const surveySave = getSurveySave(stateful, test_id);
    const cloneSurveySave = _.cloneDeep(surveySave);
    return {
        subject_items: [],
        answers: _.merge(cloneSurveySave.server.answers, cloneSurveySave.client.answers),
    };
};
